import {makeStyles} from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import Toggle from '../../Atoms/Toggle';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import DiscoverList from "../DiscoverList/DiscoverList";

export interface INotificationFormDetails {
    nameField: string;
    handleNameChange: any;
    nameEmpty: boolean;
    isPushNotification: boolean;
    toggleIsPushNotification: Function;
    pushNotificationDeepLinkingDestination: "inbox" | "discover" | "moments";
    selectPushNotificationDeepLinkingDestinationCategory: any
    selectedDiscoverCard: any;
    setSelectedDiscoverCard: any;
}

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
    },
    input: {
        display: 'none',
    },
}));

const NotificationFormDetails = ({
     handleNameChange,
     isPushNotification,
     nameEmpty,
     nameField,
     toggleIsPushNotification,
     pushNotificationDeepLinkingDestination,
     selectPushNotificationDeepLinkingDestinationCategory,
     selectedDiscoverCard, setSelectedDiscoverCard
}: INotificationFormDetails) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Typography gutterBottom variant="h6">
                Details
            </Typography>
            <Grid container>
                <Grid container spacing={3} direction={"column"} item sm={6} xs={12}>
                    <Grid item>
                        <Toggle
                            label={"Send as push notification?"}
                            checked={isPushNotification}
                            onChange={toggleIsPushNotification}
                        />
                    </Grid>
                    {isPushNotification && <Grid item>
                        <label>Where should user be taken? </label>

                        <Select value={pushNotificationDeepLinkingDestination} onChange={(evt) => {
                            selectPushNotificationDeepLinkingDestinationCategory(evt.target.value)
                        }}>
                            <MenuItem value={"discover"}>
                                Discover
                            </MenuItem>
                            <MenuItem value={"inbox"}>
                                Inbox
                            </MenuItem>
                            <MenuItem value={"itinerary"}>
                                Itinerary
                            </MenuItem>

                            <MenuItem value={"moments"}>
                                Moments
                            </MenuItem>

                            <MenuItem value={"profile"}>
                                Profile
                            </MenuItem>
                        </Select>
                    </Grid>}
                    {isPushNotification && pushNotificationDeepLinkingDestination === "discover" &&
                        <DiscoverList selectedDiscoverCard={selectedDiscoverCard}
                                      setSelectedDiscoverCard={setSelectedDiscoverCard}/>
                    }
                </Grid>
                <Grid item sm={6} xs={12}>
                    <FormControl className={classes.formControl} error={nameEmpty}>
                        <TextField
                            aria-describedby="component-error-text"
                            autoFocus
                            id="component-error"
                            multiline
                            onChange={handleNameChange}
                            placeholder="Message text"
                            rows={3}
                            value={nameField}
                        />
                        <FormHelperText id="component-error-text">Please enter your message above</FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default NotificationFormDetails;
